// extracted by mini-css-extract-plugin
module.exports = {"BoxCustomContainer":"CustomContainer_BoxCustomContainer__2zKfm","TitleContainer":"CustomContainer_TitleContainer__3GGhu"};